import RequiredValidator from "./required_validator"
import FormValueGetter from "../form_value_getter"

export default class QuestionValidator {
  constructor(questionCard) {
    this.questionCard = questionCard
    this.isRequired = questionCard.getAttribute('data-question-required')
    this.questionKind = questionCard.getAttribute('data-question-kind')
    this.questionId = questionCard.getAttribute('data-question-id')
    this.fieldValue = new FormValueGetter(questionCard).getValue()
    this.setMinMaxValues()
  }

  validate() {
    if (this.isRequired == 'true') {
      if (this.validateRequired() == false) { return false }
    }

    if(isNaN(this.maxValue) === false && isNaN(this.minValue) === false) {
      if (this.fieldValue == '') { return true }
      if (this.fieldValue >= this.minValue && this.fieldValue <= this.maxValue) { return true }

      this.setFieldErrorClass()
      return false
    }

    return true
    // todo: others selected but empty
  }

  validateRequired(){
    const isValid = RequiredValidator.validate(this.questionKind, this.fieldValue)
    if (isValid) { return true }

    this.setFieldErrorClass()
    return false
  }

  setMinMaxValues(){
    if (this.questionKind != 'integer_field') { return }

    const inputField = this.questionCard.getElementsByTagName('input')[0]
    this.minValue = parseInt(inputField.getAttribute('data-min-value'))
    this.maxValue = parseInt(inputField.getAttribute('data-max-value'))
  }

  setFieldErrorClass(){
    if (this.questionKind === 'text_field') { this.setTextFieldInvalid() }
    if (this.questionKind === 'integer_field') { this.setTextFieldInvalid() }
    if (this.questionKind === 'gender') { this.setGenderFieldInvalid() }
    if (this.questionKind === 'boolean') { this.setBooleanFieldInvalid() }
    if (this.questionKind === 'radio') { this.setRadioFieldInvalid() }
    if (this.questionKind === 'check') { this.setCheckFieldInvalid() }
    if (this.questionKind === 'check_with_others_option') { this.setCheckWithOtherOptionFieldInvalid() }
    if (this.questionKind === 'boolean_with_complementary_options_on_false') { this.setBooleanWithJustificationFieldInvalid() }
    if (this.questionKind === 'radio_with_others_option') { this.setRadioWithOthersOptionsFieldInvalid() }
  }

  setTextFieldInvalid(){
    this.questionCard.getElementsByTagName('input')[0].classList.add('is-invalid')
  }

  setGenderFieldInvalid() {
    const options = this.questionCard.querySelectorAll('input[name="gender"]')
    options.forEach(element => element.classList.add('is-invalid'))
  }

  setBooleanFieldInvalid() {
    const fieldQuery = `input[name="${this.questionId}-boolean"]`
    const options = this.questionCard.querySelectorAll(fieldQuery)
    options.forEach(element => element.classList.add('is-invalid'))
  }

  setRadioFieldInvalid(){
    this.questionCard.getElementsByTagName('select')[0].classList.add('is-invalid')
  }

  setCheckFieldInvalid(){
    const checks = Array.from(this.questionCard.getElementsByTagName('input'))
    checks.forEach(element => element.classList.add('is-invalid'))
  }

  setCheckWithOtherOptionFieldInvalid() {
    const checks = Array.from(this.questionCard.getElementsByTagName('input'))
    checks.forEach(element => element.classList.add('is-invalid'))
  }

  setBooleanWithJustificationFieldInvalid() {
    const fieldQuery = `input[name="${this.questionId}-boolean-with-justification"]`
    const options = this.questionCard.querySelectorAll(fieldQuery)
    options.forEach(element => element.classList.add('is-invalid'))
  }

  setRadioWithOthersOptionsFieldInvalid() {
    this.questionCard.getElementsByTagName('select')[0].classList.add('is-invalid')
  }
}
